import React, { useState, useCallback } from 'react';

const LtiResourceContext = React.createContext([
    undefined,
    () => {
        // no-op
    },
]);
function LtiResourceContextProvider({ children, decodeLtiResponseJwt, }) {
    const [ltiResource, setLtiResource] = useState(undefined);
    const processLtiResponse = useCallback((jwt) => {
        if (jwt) {
            return setLtiResource(decodeLtiResponseJwt(jwt));
        }
        setLtiResource(undefined);
    }, [decodeLtiResponseJwt]);
    return React.createElement(LtiResourceContext.Provider, { value: [ltiResource, processLtiResponse] }, children);
}

export { LtiResourceContext, LtiResourceContextProvider };
